export default __webpack_public_path__ + "static/media/previous.d91a982c.svg";